import React, { useEffect, useState } from "react";
import TabProduct from "./TabProduct";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import { ImageBaseUrl, QueryPath } from "src/lib/constans";
import DotsLoaderAnimation from "../Loaders/DotsLoaderAnimation";
import {
  convertToKebabCase,
  getGridSizeData,
  parseQueryParams,
} from "src/helpers/helperFunctions";
import { useNavigate } from "react-router-dom";

const OnlinePharmacyHoveredTab = ({
  id,
  style,
  onClose,
  allMainCategory,
  setAllMainCategory,
  allSubCategory,
  setAllSubCategory,
  allChildCategory,
  setAllChildCategory,
  loader,
  setLoader,
  setActiveMainCategory,
  setActiveSubCategory,
  activeMainCategory,
  activeSubCategory,
}: {
  id: string;
  style: React.CSSProperties;
  onClose: () => void;
  allMainCategory: any[];
  setAllMainCategory: (allMainCategory: any[]) => void;
  allSubCategory: any[];
  setAllSubCategory: (allSubCategory: any[]) => void;
  allChildCategory: any[];
  setAllChildCategory: (allChildCategory: any[]) => void;
  loader: boolean;
  setLoader: (loader: boolean) => void;
  setActiveMainCategory: (activeMainCategory: string) => void;
  setActiveSubCategory: (activeSubCategory: string) => void;
  activeMainCategory: string;
  activeSubCategory: string;
}) => {
  const navigate = useNavigate();
  const getAllCategories = async () => {
    if (
      allMainCategory.length === 0 ||
      allSubCategory.length === 0 ||
      allChildCategory.length === 0
    ) {
      setLoader(true);
      const { res, err } = await httpRequest<{
        mainCategory: any[];
        subCategory: any[];
        childCategory: any[];
      }>({
        path: "/main-category/home/all-categories",
      });
      if (res) {
        let data = res;
        setAllMainCategory(data.mainCategory);
        setAllSubCategory(data.subCategory);
        setAllChildCategory(data.childCategory);
        setActiveMainCategory(data.mainCategory[0]._id);
        setActiveSubCategory(
          data.subCategory.filter(
            (item: any) => item.mainCategoryId === data.mainCategory[0]._id
          )[0]._id
        );
      } else {
        toast(err, { type: "error" });
      }
    }
    setLoader(false);
  };

  useEffect(() => {
    getAllCategories();
  }, []);

  let { gridCols, totalDataLength } = getGridSizeData({
    extraLarge: 4,
    large: 3,
    medium: 3,
    small: 2,
    rows: 3,
  });
  return (
    <div
      id={id}
      className="relative p-1 pt-0 w-full h-fit min-h-[300px] xl:min-h-[400px]"
    >
      <div
        style={style}
        className="min-w-full p-2 2xl:p-4 h-fit rounded-br-md rounded-bl-md shadow bg-white relative"
      >
        {loader ? (
          <div className="flex justify-center items-center h-[200px] w-full  ">
            <DotsLoaderAnimation />
          </div>
        ) : (
          <div className="flex gap-1.5 xl:gap-2 w-full">
            <div className="flex flex-col w-[150px] md:w-[190px] lg:w-[220px] 2xl:w-[270px] max-h-[280px] 2xl:max-h-[340px] overflow-y-auto custom-ai-scroll-bar ">
              {allMainCategory.map((item, index) => (
                <div
                  key={"Main Category" + index}
                  className={`py-[2px] ${
                    index !== allMainCategory.length - 1 &&
                    "border-b border-gray-300"
                  } cursor-pointer group`}
                  onClick={() => {
                    setActiveMainCategory(item._id);
                    navigate(
                      `/category/${convertToKebabCase(
                        item?.categoryName
                      )}?${parseQueryParams({
                        [QueryPath.mainCategory]: item?._id,
                        [QueryPath.mainCategoryName]: item?.categoryName,
                      })}`
                    );
                    onClose();
                  }}
                  id={`main-category-${index}`}
                  onMouseEnter={() => {
                    setActiveMainCategory(item._id);
                    setActiveSubCategory(
                      allSubCategory.find(
                        (subItem: any) => subItem.mainCategoryId === item?._id
                      )?._id
                    );
                  }}
                >
                  <div
                    className={`${
                      activeMainCategory === item._id
                        ? "theme-gradient-green-bottom text-white font-Poppins-Medium"
                        : "text-[#404040] group-hover:bg-gray-100 font-Poppins-Regular"
                    } py-2 px-3 rounded  font-size-18px`}
                  >
                    {item.categoryName}
                  </div>
                </div>
              ))}
            </div>
            <div className="flex flex-col shadow-all-light h-full max-h-[280px] 2xl:max-h-[340px] overflow-y-auto custom-ai-scroll-bar w-[150px] md:w-[190px] lg:w-[220px] 2xl:w-[270px] rounded-md bg-[#f6faff]">
              {allSubCategory
                .filter(
                  (item: any) => item.mainCategoryId === activeMainCategory
                )
                .map((item, index) => (
                  <div
                    key={"Sub Category" + index}
                    className={`p-[2px] ${
                      index !==
                        allSubCategory.filter(
                          (item: any) =>
                            item.mainCategoryId === activeMainCategory
                        ).length -
                          1 && "border-b border-gray-300"
                    } cursor-pointer group`}
                    id={`sub-category-${index}`}
                    onClick={() => {
                      navigate(
                        `/category/${convertToKebabCase(
                          allMainCategory.find(
                            (mainItem: any) =>
                              mainItem._id === activeMainCategory
                          )?.categoryName
                        )}/${convertToKebabCase(
                          item?.subCategoryName
                        )}?${parseQueryParams({
                          [QueryPath.mainCategory]: activeMainCategory,
                          [QueryPath.mainCategoryName]: allMainCategory.find(
                            (mainItem: any) =>
                              mainItem._id === activeMainCategory
                          )?.categoryName,
                          [QueryPath.subCategory]: item?._id,
                          [QueryPath.subCategoryName]: item?.subCategoryName,
                        })}`
                      );
                      onClose();
                    }}
                    onMouseEnter={() => setActiveSubCategory(item._id)}
                  >
                    <div
                      className={`${
                        activeSubCategory === item._id
                          ? "bg-[#FFE175] text-[#00443F] font-Poppins-Medium"
                          : "text-[#404040] group-hover:bg-gray-100 font-Poppins-Regular"
                      } py-2 px-3 rounded  font-size-16px`}
                    >
                      {item.subCategoryName}
                    </div>
                  </div>
                ))}
            </div>
            <div className="flex flex-1 relative overflow-y-auto custom-ai-scroll-bar">
              <div
                className={`absolute top-0 left-0 w-full h-fit overflow-y-auto py-1 grid grid-cols-${gridCols} gap-2 xl:gap-3 2xl:gap-4 px-1 xl:px-2`}
              >
                {allChildCategory
                  .filter(
                    (item: any) => item.subCategoryId === activeSubCategory
                  )
                  // .slice(0, totalDataLength)
                  .map((item, index) => (
                    <TabProduct
                      key={"Product" + index}
                      data={{
                        name: item?.childCategoryName,
                        image:  item?.childCategoryImage,
                      }}
                      id={`child-category-${index}`}
                      onClick={() => {
                        navigate(
                          `/category/${convertToKebabCase(
                            allMainCategory.find(
                              (mainItem: any) =>
                                mainItem._id === activeMainCategory
                            )?.categoryName
                          )}/${convertToKebabCase(
                            allSubCategory.find(
                              (subItem: any) =>
                                subItem._id === activeSubCategory
                            )?.subCategoryName
                          )}/${convertToKebabCase(
                            item?.childCategoryName
                          )}?${parseQueryParams({
                            [QueryPath.mainCategory]: activeMainCategory,
                            [QueryPath.mainCategoryName]: allMainCategory.find(
                              (mainItem: any) =>
                                mainItem._id === activeMainCategory
                            )?.categoryName,
                            [QueryPath.subCategory]: activeSubCategory,
                            [QueryPath.subCategoryName]: allSubCategory.find(
                              (subItem: any) =>
                                subItem._id === activeSubCategory
                            )?.subCategoryName,
                            [QueryPath.childCategory]: item?._id,
                            [QueryPath.childCategoryName]:
                              item?.childCategoryName,
                          })}`
                        );
                        onClose();
                      }}
                      fontSmall={true}
                    />
                  ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OnlinePharmacyHoveredTab;
